export default "__VITE_ASSET__DHC$5gmq__"